import React, { useCallback, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import profile from "../../images/Icons/man.png";
import camera from "../../images/Icons/camera.png";
import success from "../../images/Icons/success.png";
import upload from "../../images/Icons/upload.png";
import rejected from "../../images/Icons/rejected.png";
import pending from "../../images/Icons/pending.png";
import { useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";
import { toast } from "react-toastify";
import useLogout from "../Auth/useLogout";

export default function SupplierProfile() {
  const [searchParams, setSearchParams] = useSearchParams();
  const logout = useLogout();
  const [sellerType, setSellerType] = useState([]);
  const [loading, isLoading] = useState(false);
  const [data, setData] = useState({});

  const shouldStartInEditMode = searchParams.get('edit') === 'true';

  useEffect(() => {
    axios
      .get(`${config.apiUrl}/registration-form-info`)
      .then((res) => {
        setSellerType(res.data.seller_type);
      })
      .catch((error) => { });
  }, []);
  const [responseError, setResponseError] = useState({
    nameError: "",
    gstError: "",
    companyNameError: "",
    emailError: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    company_name: "",
    gst_number: "",
    pan_number: "",
    company_address: "",
    phone: "",
    email: "",
    supplier: "",
    address_line_one: "",
    address_line_two: "",
    postal_code: "",
    city: "",
    state: "",
  });
  const fetchUserProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/seller/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setData(response.data.data);
      setFormData((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        company_name: response.data.data.business_details?.name ?? "",
        gst_number: response.data.data.kyc_details?.gst_number ?? "",
        pan_number: response.data.data.kyc_details?.identity_number ?? "",
        company_address: response.data.data.kyc_details?.address ?? "",
        phone: response.data.data.phone ?? "",
        email: response.data.data.email ?? "",
        supplier: response.data.data.business_details?.seller_type?.[0]?.id ?? "",
        kyc_status: response.data.data.kyc_details?.status ?? "",
        address_line_one: response.data.data.kyc_details?.address_line_one ?? "",
        address_line_two: response.data.data.kyc_details?.address_line_two ?? "",
        city: response.data.data.kyc_details?.city ?? "",
        state: response.data.data.kyc_details?.state ?? "",
        postal_code: response.data.data.kyc_details?.postal_code ?? "",
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout]);
  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateData = () => {
    const newErrors = {};
    if (!formData.name) {
      newErrors.nameError = "Name is required";
    }
    if (!formData.company_name) {
      newErrors.companyNameError = "Company name is required";
    }
    if (!formData.gst_number) {
      newErrors.gstError = "GST number is required";
    }

    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.emailError = "Invalid email format";
      }
    }

    if (!formData.email) {
      newErrors.emailError = "Email is required";
    }

    setResponseError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateData()) {
      isLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/seller/update-profile`,
          {
            user_name: formData.name,
            email: formData.email,
            seller_type: formData.supplier ? [+formData.supplier] : [],
            gst_number: formData.gst_number,
            pan_number: formData.pan_number,
            company_name: formData.company_name,
            address_line_one: formData.address_line_one,
            address_line_two: formData.address_line_two,
            city: formData.city,
            state: formData.state,
            pin_code: formData.postal_code,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );
        var localData = {
          name: response.data.data.name,
          type: response.data.data.type,
          email: response.data.data.email,
          phone: response.data.data.phone,
        };
        Cookies.set("bz_uinf", JSON.stringify(localData), { expires: 7 });
        config.user =
          Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setMode("show");
        
        if (searchParams.get('edit') === 'true') {
          setSearchParams({}, { replace: true });
        }

        fetchUserProfile();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        isLoading(false);
      }
    }
  };
  const [mode, setMode] = useState(shouldStartInEditMode ? "edit" : "show");
  const handleMode = (mode) => {
    setMode(mode);
  };
  const user = config.user;
  const userType = user ? user.type : "";

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="row-layout dashborad-profile">
                <div className="card mb-2">
                  <div className="card-body text-center p-0">
                    <div className="user-image">
                      <img src={profile} alt="" />
                      <div className="edit-image" title="User Profile">
                        <img src={camera} alt="" />
                      </div>
                    </div>
                    <h6 className="text-center mt-1 mb-0">
                      {formData.name}
                    </h6>
                    {data.is_staff ? (
                      <p className="text-center m-0 text-capitalize">
                        {userType} Staff ({ data.role ?? "N/A" })
                      </p>
                    ) : (
                      <p className="text-center m-0 text-capitalize">
                        {userType}/Buyer
                      </p>
                    )}
                    <div className="row-hd-txt-center">
                      {formData.kyc_status === "pending" ? (
                        <>
                          <img src={pending} alt="icon" />
                          <h5 className="text-pending">Pending</h5>
                        </>
                      ) : formData.kyc_status === "approved" ? (
                        <>
                          <img src={success} alt="icon" />
                          <h5 className="text-success">Approved</h5>
                        </>
                      ) : formData.kyc_status === "uploaded" ? (
                        <>
                          <img src={upload} alt="icon" />
                          <h5 className="text-pending">Uploaded</h5>
                        </>
                      ) : formData.kyc_status === "rejected" ? (
                        <>
                          <img src={rejected} alt="icon" />
                          <h5 className="text-danger">Rejected</h5>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-6">
                    <h6 className="mb-0">
                      {mode === "show" ? "Personal" : "Edit"} Information
                    </h6>
                  </div>
                  <div className="col-6 text-end">
                    {mode === "show" ? (
                      <button
                        type="button"
                        className="add-edit-btn"
                        onClick={() => handleMode("edit")}
                      >
                        <i className="bi bi-pencil"></i>Edit
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="add-edit-btn"
                        onClick={() => handleMode("show")}
                      >
                        <i className="bi bi-x-lg"></i>Cancel
                      </button>
                    )}
                    <Link to="/address" type="button" className="add-edit-btn ms-2">
                      <i className="bi bi-chevron-double-right"></i>Next
                    </Link>
                  </div>
                </div>

                {mode === "show" ? (
                  <div className="row mt-2">
                    <div className="col-lg-12">
                      <table className="table table-bordered detail_table">
                        <tbody>
                          <tr>
                            <td>Name:</td>
                            <td>
                              <span>{formData.name}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Company Name:</td>
                            <td>
                              <span>{formData.company_name || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>GST Number:</td>
                            <td>
                              <span>{formData.gst_number || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>PAN Number:</td>
                            <td>
                              <span>{formData.pan_number || "---"}</span>
                            </td>
                          </tr>
                          {/* <tr>
                            <td>Company Address:</td>
                            <td>
                              <span>{formData.company_address || "---"}</span>
                            </td>
                          </tr> */}
                          <tr>
                            <td>Phone Number:</td>
                            <td>
                              <span>{formData.phone}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Email Address:</td>
                            <td>
                              <span>{formData.email || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Seller Type:</td>
                            <td>
                              <span>
                                {formData.supplier
                                  ? sellerType.find(
                                    (s) => s.id === formData.supplier
                                  )?.name
                                  : "---"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Address Line One:</td>
                            <td>
                              <span>{formData.address_line_one || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Address Line Two:</td>
                            <td>
                              <span>{formData.address_line_two || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>City:</td>
                            <td>
                              <span>{formData.city || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>State:</td>
                            <td>
                              <span>{formData.state || "---"}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Pin Code:</td>
                            <td>
                              <span>{formData.postal_code || "---"}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <form className="dashboard-form mt-1" onSubmit={handleSubmit}>
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <label className="label" htmlFor="name">
                          Name
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter name"
                          />
                        </div>
                        {responseError.nameError && (
                          <small className="input-error">
                            {responseError.nameError}
                          </small>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="company_name">
                          Company Name
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="company_name"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleChange}
                            placeholder="Enter company name"
                          />
                        </div>
                        {responseError.companyNameError && (
                          <small className="input-error">
                            {responseError.companyNameError}
                          </small>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="supplier">
                          Seller Type
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-box-fill"></i>
                          </span>
                          <select
                            className="form-control"
                            id="supplier"
                            name="supplier"
                            value={formData.supplier}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select Type
                            </option>
                            {sellerType.map((stype) => {
                              return (
                                <option value={stype.id} key={stype.id}>
                                  {stype.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="email">
                          Email
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-envelope-fill"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="Enter email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                        {responseError.emailError && (
                          <small className="input-error">
                            {responseError.emailError}
                          </small>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="label" htmlFor="gst_number">
                          Gst Number
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="gst_number"
                            placeholder="Enter gst number"
                            name="gst_number"
                            value={formData.gst_number}
                            onChange={handleChange}
                          />
                        </div>
                        {responseError.gstError && (
                          <small className="input-error">
                            {responseError.gstError}
                          </small>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="pan_number">
                          Pan Number
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="pan_number"
                            placeholder="Enter pan number"
                            name="pan_number"
                            value={formData.pan_number}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <label className="form-label" htmlFor="address_line_one">
                          Address Line One
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="address_line_one"
                            placeholder="Enter address line one"
                            name="address_line_one"
                            value={formData.address_line_one}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <label className="form-label" htmlFor="address_line_two">
                          Address Line Two
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="address_line_two"
                            placeholder="Enter address line two"
                            name="address_line_two"
                            value={formData.address_line_two}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="city">
                          City
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="city"
                            placeholder="Enter city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="state">
                          State
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="state"
                            placeholder="Enter state"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <label className="form-label" htmlFor="pincode">
                          Pincode
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-person-vcard-fill"></i>
                          </span>
                          <input
                            type="number"
                            className="form-control"
                            id="pincode"
                            placeholder="Enter pincode"
                            name="postal_code"
                            value={formData.postal_code}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* <div className="col-lg-12">
                        <label className="form-label" htmlFor="company_address">
                          Company Address
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bi bi-building-fill"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            id="company_address"
                            placeholder="Enter company address"
                            name="company_address"
                            value={formData.company_address}
                            onChange={handleChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-lg-12 text-end">
                        <button
                          type="submit"
                          disabled={loading}
                          className="submit_btn"
                        >
                          <i className="bi bi-floppy"></i>
                          {loading ? "Submitting" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
